var React = require('react');

function IconLogoWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFFFFF","d":"M41.8,18.4V0h18.2v18.4H41.8z M0,0h20.9L10.5,18.4L0,0z M38.6,9.2c0,5.1-4.1,9.2-9.1,9.2s-9.1-4.1-9.1-9.2\n\tS24.5,0,29.5,0S38.6,4.1,38.6,9.2z"}));
}

IconLogoWhite.defaultProps = {"width":"61px","height":"19px","viewBox":"0 0 61 19"};

module.exports = IconLogoWhite;

IconLogoWhite.default = IconLogoWhite;
